"use client";

import { c as _c } from "react/compiler-runtime";
import { AlertTriangle } from "lucide-react";
export function MapConfigurationError() {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-red-500 mb-4"><AlertTriangle className="w-12 h-12 mx-auto" /></div>;
    t1 = <h3 className="text-lg font-semibold text-red-900 mb-2">Map Configuration Error</h3>;
    t2 = <p className="text-sm text-red-700 mb-4">The Google Maps API is not properly configured. Please check your API key and domain settings.</p>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="font-semibold mb-2">Common issues:</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center justify-center h-64 bg-red-50 rounded-lg border border-red-200"><div className="text-center p-6">{t0}{t1}{t2}<div className="text-xs text-red-600 text-left">{t3}<ul className="list-disc list-inside space-y-1"><li>Missing or invalid API key</li><li>API key not enabled for required services</li><li>Domain not authorized for this API key</li><li>API quota exceeded</li></ul></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export function MapNetworkError(t0) {
  const $ = _c(7);
  const {
    retry
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-yellow-500 mb-4"><AlertTriangle className="w-12 h-12 mx-auto" /></div>;
    t2 = <h3 className="text-lg font-semibold text-yellow-900 mb-2">Network Error</h3>;
    t3 = <p className="text-sm text-yellow-700 mb-4">Unable to connect to the map service. Please check your internet connection.</p>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== retry) {
    t4 = retry && <button onClick={retry} className="px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 transition-colors text-sm">Retry Connection</button>;
    $[3] = retry;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="flex items-center justify-center h-64 bg-yellow-50 rounded-lg border border-yellow-200"><div className="text-center p-6">{t1}{t2}{t3}{t4}</div></div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}